// components/ui/spinner.tsx
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "default" | "lg" | "icon";
  fullScreen?: boolean;
  message?: string;
}

function RefurblySpinner({ sizePx = 72 }: { sizePx?: number }) {
  return (
    <span
      className="rb-spinner"
      style={{ fontSize: sizePx }}
      role="status"
      aria-label="Loading"
    >
      <span className="rb-spinner__orbit">
        <span className="rb-spinner__arm">
          <span className="rb-spinner__counter">
            <span className="rb-spinner__tile" />
          </span>
        </span>
      </span>
      <span className="rb-spinner__orbit rb-spinner__orbit--b">
        <span className="rb-spinner__arm">
          <span className="rb-spinner__counter">
            <span className="rb-spinner__tile" />
          </span>
        </span>
      </span>
    </span>
  );
}

export function Spinner({
  className,
  size = "default",
  fullScreen = false,
  message,
  ...props
}: SpinnerProps) {
  const spinnerContent = (
    <div
      role="status"
      className={cn(
        "flex flex-col items-center justify-center space-y-4",
        className
      )}
      {...props}
    >
      {fullScreen ? (
        <RefurblySpinner sizePx={80} />
      ) : (
        <Loader2
          className={cn("animate-spin", {
            "h-4 w-4": size === "sm",
            "h-6 w-6": size === "default",
            "h-8 w-8": size === "lg",
            "h-4 w-4 text-muted-foreground": size === "icon",
          })}
        />
      )}
      {message && <p className="text-sm text-muted-foreground">{message}</p>}
      <span className="sr-only">Loading...</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 grid place-items-center bg-background">
        {spinnerContent}
      </div>
    );
  }

  return spinnerContent;
}
